/** AI创作分类 */
export enum AI_CREATORS_TYPE {
  SAME_STYlE = 'SAME_STYlE',
  PICTURE_COUNT = 'PICTURE_COUNT',
  FANS_COUNT = 'FANS_COUNT',
}
